/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralServiceDocumentsRepository = (
    options: GeneralRestApiOptions
): Types.GeneralServiceDocumentsRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/serviceDocuments/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
